import { transformLineItemToBE } from './transformLineItemToBE'

export const formatSeparateLineItemPerEachInventoryItem = ({
  values,
  formattedInventory,
  campaignId,
  right,
  currency
}) => {
  return formattedInventory.map(inventoryItem => {
    const { microAmount, units } = inventoryItem

    return transformLineItemToBE({
      inventory: [inventoryItem],
      values,
      campaignId,
      units,
      microAmount,
      right,
      currency
    })
  })
}
